import { useNavigate } from 'react-router-dom';
import { useState} from "react";
import useFetchPOST from "../useFetchPOST";
import CustomError from '../CustomError';
const New = () => {
    const [formData, setFormData] = useState({
        invoiceNo: '',
        invoiceDate: '',
        invoiceClient: '',
        invoiceAmount: '0'
    })
    
    const [submitData, setSubmitData] = useState(null); // State to trigger fetch
    const {error} = useFetchPOST('https://api.plusat.be/invoices', submitData);
    const navigator = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
      };
      
    const handleSubmit = async (e) => {
        e.preventDefault();                    
        setSubmitData(formData);        
        
        setTimeout( () => {
            navigator('/index');
        }, 500)
    };      
    
    return (
        <div className="new">
            <h2>Please input all details for a new invoice</h2>
            <form onSubmit={handleSubmit}>            
                <fieldset className="new-panel">
                    <legend>Details:</legend>
                    <label htmlFor="invoiceNo">Invoice no: &nbsp;</label><input type="text" name="invoiceNo" id="invoiceNo" value={formData.invoiceNo} onChange={handleChange}/>
                    <label htmlFor="invoiceDate">Invoice date: &nbsp;</label><input type="text" name="invoiceDate" id="invoiceDate" value={formData.invoiceDate} onChange={handleChange}/>
                    <label htmlFor="invoiceClient">Client: &nbsp;</label><input type="text" name="invoiceClient" id="invoiceClient" value={formData.invoiceClient} onChange={handleChange}/>
                    <label htmlFor="invoiceAmount">Amount: &nbsp;</label><input type="text" name="invoiceAmount" id="invoiceAmount" value={formData.invoiceAmount} onChange={handleChange}/>
                </fieldset>
                <br />                
                <button type="submit">Save invoice</button>
            </form>

            {error && <CustomError error={error}/>}       
        </div>
    )
}

export default New;